import { memo } from 'react'
import { Skeleton } from './Skeleton'

export const AnalyticsSkeleton = memo(function AnalyticsSkeleton() {
  return (
    <div className="flex flex-col gap-6 p-6">
      <Skeleton className="h-7 w-32" />

      {[...Array(3)].map((_, i) => (
        <div key={i} className="rounded-xl border border-border bg-card p-4">
          <Skeleton className="mb-2 h-4 w-24" />
          <Skeleton className="mb-2 h-8 w-20" />
          <div className="flex items-center gap-2">
            <Skeleton className="h-4 w-12" />
            <Skeleton className="h-4 w-32" />
          </div>
        </div>
      ))}

      <div className="rounded-xl border border-border bg-card p-4">
        <Skeleton className="mb-4 h-5 w-40" />
        <div className="flex flex-col gap-4">
          {[...Array(2)].map((_, i) => (
            <div key={i}>
              <div className="mb-2 flex justify-between">
                <Skeleton className="h-4 w-20" />
                <Skeleton className="h-4 w-10" />
              </div>
              <Skeleton className="h-2 w-full" />
            </div>
          ))}
        </div>
      </div>
    </div>
  )
})
